import React, { useContext, useEffect } from 'react';
import BSSDataContext from '../../contexts/BSSDataContext';
import __t from '../../lib/traduzioni';


const TrackerQS = () => {

    const params = new URLSearchParams(window.location.search);
    const corriereqs = params.get('corriere');
    const numeroqs = params.get('numerotracking');

    const contesto = useContext(BSSDataContext);

    const daticorriere = (corriereqs) && (contesto[corriereqs] ?? null);

    const vaiAPaginaCorriere = (daticorriere, numerotracking) => {
        window.open(
            daticorriere.url.replace("%s", numerotracking),
            '_blank'
        );
    }

    useEffect(()=>{
        if(daticorriere !== null){
            if(numeroqs !== null){
                vaiAPaginaCorriere(daticorriere, numeroqs)
            }
        }
    }, [daticorriere])

    return daticorriere ? (
        <></>
    ) : (
        <div>
            {`${corriereqs}: ${__t("corrierenonsupportato")}!`}
        </div>
    );
    
}



export default TrackerQS;